import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export function useAccessRole() {
  const store = useStore();

  const accessRole = computed(() => store.state.accessRole);
  const tenant = computed(() => store.state.tenant);
  const fetchingTenant = computed(() => store.state.fetchingTenant);

  const fetchAccessRole = () => store.dispatch("fetchAccessRole");
  const fetchTenant = () => store.dispatch("fetchTenant");
  const rbacEnabled = computed(() =>
    store.getters.featureEnabledForTenant("rbac")
  );

  const canAccess = (...permissions) => {
    if (!tenant.value) return false;
    if (!rbacEnabled.value) return true;

    const role = accessRole.value;
    if (!role || !role.permissions) {
      return false;
    }
    return role.permissions.some((permission) =>
      permissions.includes(permission.key)
    );
  };

  onMounted(() => {
    if (!tenant.value && !fetchingTenant.value) {
      fetchTenant();
    }

    fetchAccessRole().catch(() => {
      window.notify.error(
        "An error occurred when loading user permission data"
      );
    });
  });

  return {
    canAccess
  };
}
